package org.moxultimate.topwithmox.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import org.moxultimate.topwithmox.components.layouts.PageLayoutData
import org.moxultimate.topwithmox.components.restricted.RestrictedPage
import org.moxultimate.topwithmox.core.toggle.FeatureToggle
import org.moxultimate.topwithmox.showscrud.main.ShowsCRUDPage

@InitRoute
fun initShowsCRUDRoute(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Shows CRUD"))
}

/**
 * ShowsCRUDRoute
 * Renders [ShowsCRUDPage] when [FeatureToggle.SHOW_CRUD_TOGGLE] is enabled,
 * otherwise shows [RestrictedPage].
 */
@Page(routeOverride = "shows-crud")
@Layout(".components.layouts.PageLayout")
@Composable
fun ShowsCRUDRoute() {
    if (FeatureToggle.SHOW_CRUD_TOGGLE) ShowsCRUDPage() else RestrictedPage()
}
